var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-lov"},[_c('h1',[_vm._v("List of Values")]),_c('EditLov')],1)}
var staticRenderFns = []

export { render, staticRenderFns }